// import { uploadManager } from "./UploadContext";

export function saveUploadState(data:any){
    // if (controller.signal.aborted) return;
    localStorage.setItem("activeUpload", JSON.stringify({...data, active: true}));
}

export function getUploadState(){
  const data = localStorage.getItem("activeUpload");
  try {
    return (data && data !== "undefined") ? JSON.parse(data) : null;
  } catch {
    return null;
  }
}
// export function getUploadState(){
//   const data = localStorage.getItem("activeUpload");
//   if(!data) return null;

//   const parsed = JSON.parse(data);

//   if(!uploadManager.get(parsed.uploadId)){
//       localStorage.removeItem("activeUpload");
//       return null;
//   }

//   return parsed;
// }

export function clearUploadState(){
    console.log("Upload cleared"); 
    localStorage.removeItem("activeUpload");
}